/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./theme/scripts/app.js":
/*!******************************!*\
  !*** ./theme/scripts/app.js ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _components_DesktopMegamenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/DesktopMegamenu */ "./theme/scripts/components/DesktopMegamenu.js");
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/Header */ "./theme/scripts/components/Header.js");
/* harmony import */ var _components_MenuDrawer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/components/MenuDrawer */ "./theme/scripts/components/MenuDrawer.js");
/* harmony import */ var _components_SearchDrawer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/components/SearchDrawer */ "./theme/scripts/components/SearchDrawer.js");
/* harmony import */ var _pages_Product__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/pages/Product */ "./theme/scripts/pages/Product.js");






var initialState = {
  searchDrawer: {
    isActive: false
  }
};
var components = {
  DesktopMegamenu: _components_DesktopMegamenu__WEBPACK_IMPORTED_MODULE_1__["default"],
  Header: _components_Header__WEBPACK_IMPORTED_MODULE_2__["default"],
  MenuDrawer: _components_MenuDrawer__WEBPACK_IMPORTED_MODULE_3__["default"],
  Product: _pages_Product__WEBPACK_IMPORTED_MODULE_5__["default"],
  SearchDrawer: _components_SearchDrawer__WEBPACK_IMPORTED_MODULE_4__["default"]
};
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.picoapp)(components, initialState));

/***/ }),

/***/ "./theme/scripts/components/DesktopMegamenu.js":
/*!*****************************************************!*\
  !*** ./theme/scripts/components/DesktopMegamenu.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");



/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_2__.component)(function (node) {
  var links = node.querySelectorAll("[data-has-childlink]");
  var siteOverlay = document.querySelector("[data-site-overlay]");
  var header = document.querySelector(".Header");
  var dropdownImage = node.querySelector("[data-dropdown-image]");
  var collections = node.querySelectorAll("[data-collection-handle]");
  var cache = {};
  links.forEach(function (childlink) {
    var childCloseDelay;
    var childOpenDelay;
    childlink.addEventListener("mouseover", function () {
      var dropdown = childlink.querySelector(".HeaderNav__DropdownInner");
      clearTimeout(childCloseDelay);
      childlink.classList.add("isVisible");
      node.style.setProperty("--header-dropdown-placeholder-height", "".concat(dropdown.offsetHeight, "px"));
      childOpenDelay = setTimeout(function () {
        childlink.classList.add("isOpen");
        header.classList.add("openMegamenu");
        siteOverlay.classList.add("!opacity-100");
      });
    });
    childlink.addEventListener("mouseleave", function () {
      clearTimeout(childOpenDelay);
      childCloseDelay = setTimeout(function () {
        childlink.classList.remove("isVisible", "isOpen");
        header.classList.remove("openMegamenu");
      }, 50);
      siteOverlay.classList.remove("!opacity-100");
      node.style.setProperty("--header-dropdown-placeholder-height", "".concat(0, "px"));
    });
  });
  var handleChangeDropdownImage = /*#__PURE__*/function () {
    var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(event) {
      var handle, url, collectionImage, response, _yield$response$json, image;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            handle = event.target.dataset.collectionHandle;
            url = "".concat(window.location.origin).concat(window.vndTheme.routes.collections, "/").concat(handle, "?view=json");
            collectionImage = null;
            if (!(cache[handle] && cache[handle].image)) {
              _context.next = 7;
              break;
            }
            collectionImage = cache[handle].image;
            _context.next = 16;
            break;
          case 7:
            _context.next = 9;
            return fetch(url);
          case 9:
            response = _context.sent;
            _context.next = 12;
            return response.json();
          case 12:
            _yield$response$json = _context.sent;
            image = _yield$response$json.image;
            cache[handle] = {
              image: image
            };
            collectionImage = image;
          case 16:
            if (collectionImage) {
              dropdownImage.src = collectionImage.src;
            }
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleChangeDropdownImage(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  if (dropdownImage) {
    collections.forEach(function (collection) {
      collection.addEventListener("mouseover", handleChangeDropdownImage);
    });
  }
}));

/***/ }),

/***/ "./theme/scripts/components/Drawer.js":
/*!********************************************!*\
  !*** ./theme/scripts/components/Drawer.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ drawer; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/app */ "./theme/scripts/app.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function drawer(node, id) {
  if (!id) {
    throw new Error("id must be provided");
  }
  var overlay = node.querySelector("[data-drawer-overlay]");
  var close = node.querySelector("[data-drawer-close]");
  var drawerToggles = document.querySelectorAll("[data-drawer-toggle=\"".concat(id, "\"]"));
  _app__WEBPACK_IMPORTED_MODULE_1__["default"].hydrate((0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, id, {
    isOpen: false
  }));
  var handleOpen = function handleOpen(element) {
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].emit("drawer:open", (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, id, _objectSpread(_objectSpread({}, _app__WEBPACK_IMPORTED_MODULE_1__["default"].getState()[id]), {}, {
      isOpen: true
    })), {
      id: id,
      element: element
    });
    node.classList.add("isVisible");
    setTimeout(function () {
      node.classList.add("isActive");
    }, 50);
  };
  var handleClose = function handleClose(element) {
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].emit("drawer:close", (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, id, _objectSpread(_objectSpread({}, _app__WEBPACK_IMPORTED_MODULE_1__["default"].getState()[id]), {}, {
      isOpen: false
    })), {
      id: id,
      element: element
    });
    node.classList.remove("isActive");
    setTimeout(function () {
      node.classList.remove("isVisible");
    }, 300);
  };
  drawerToggles.forEach(function (menuToggle) {
    menuToggle.addEventListener("click", function () {
      var isOpen = _app__WEBPACK_IMPORTED_MODULE_1__["default"].getState()[id].isOpen;
      if (isOpen) {
        handleClose(menuToggle);
        menuToggle.focus();
      } else {
        handleOpen(menuToggle);
        close === null || close === void 0 || close.focus();
      }
    });
  });
  _app__WEBPACK_IMPORTED_MODULE_1__["default"].on("drawer:open", function (state, data) {
    var drawerId = data === null || data === void 0 ? void 0 : data.id;
    if (drawerId !== id) {
      handleClose();
    }
  });
  overlay === null || overlay === void 0 || overlay.addEventListener("click", handleClose);
  close === null || close === void 0 || close.addEventListener("click", handleClose);
  return {
    unmount: function unmount() {
      overlay === null || overlay === void 0 || overlay.removeEventListener("click", handleClose);
      close === null || close === void 0 || close.removeEventListener("click", handleClose);
    },
    close: handleClose,
    open: handleOpen
  };
}

/***/ }),

/***/ "./theme/scripts/components/Header.js":
/*!********************************************!*\
  !*** ./theme/scripts/components/Header.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var cartCount = document.querySelectorAll("[data-cart-count]");
  var cartTotal = document.querySelectorAll("[data-cart-total]");
  var cartToggle = document.querySelectorAll("[data-cart-toggle]");
  var handleChangeCartTotal = function handleChangeCartTotal(price) {
    var priceHTML = "(".concat(window.Shopify.formatMoney(price), ")");
    cartTotal.forEach(function (el) {
      el.innerHTML = priceHTML;
    });
  };
  var handleChangeCartCount = function handleChangeCartCount(count) {
    cartCount.forEach(function (el) {
      if (count > 0) {
        el.style.display = "flex";
        el.innerHTML = count;
      } else {
        el.style.display = "none";
      }
    });
  };
  document.addEventListener("vnd_ajx:crt:success", function (event) {
    var _event$detail;
    if (event !== null && event !== void 0 && (_event$detail = event.detail) !== null && _event$detail !== void 0 && _event$detail.cart) {
      var cart = event.detail.cart;
      handleChangeCartCount(cart.item_count);
      handleChangeCartTotal(cart.total_price);
    }
  });
  cartToggle.forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent("vnd_ajx:crt:success", {
        bubbles: true,
        cancelable: true
      }));
    });
  });

  // Hide header on scroll page
  var lastScrollTop = 0;
  window.onscroll = function () {
    var scrollTop = document.documentElement.scrollTop;
    if (scrollTop > 150) {
      node.classList.add("announcement-remove");
    } else if (scrollTop < 100) {
      node.classList.remove("announcement-remove");
    }
    if (scrollTop > lastScrollTop && scrollTop > 150) {
      node.classList.add("header-remove");
    } else if (!document.body.classList.contains("overflow-hidden")) {
      node.classList.remove("header-remove");
    }
    lastScrollTop = scrollTop;
  };
}));

/***/ }),

/***/ "./theme/scripts/components/MenuDrawer.js":
/*!************************************************!*\
  !*** ./theme/scripts/components/MenuDrawer.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _Drawer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Drawer */ "./theme/scripts/components/Drawer.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var drawerId = "menuDrawer";
  var drawerInstance = (0,_Drawer__WEBPACK_IMPORTED_MODULE_1__["default"])(node, drawerId);
  return drawerInstance.unmount;
}));

/***/ }),

/***/ "./theme/scripts/components/SearchDrawer.js":
/*!**************************************************!*\
  !*** ./theme/scripts/components/SearchDrawer.js ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_1__.component)(function (node, ctx) {
  var siteOverlay = document.querySelector("[data-site-overlay]");
  var searchOpenTriggers = document.querySelectorAll("[data-search-drawer-trigger]");
  var searchInput = node.querySelector("input[name='q']");
  var form = node.querySelector("form");
  var setActive = function setActive() {
    node.classList.add("isActive");
    node.setAttribute("aria-hidden", "false");
    siteOverlay.classList.add("!opacity-100");
    searchInput.focus();
    ctx.hydrate({
      searchDrawer: _objectSpread(_objectSpread({}, ctx.getState().searchDrawer), {}, {
        isActive: true
      })
    });
  };
  var setInactive = function setInactive() {
    node.classList.remove("isActive");
    node.setAttribute("aria-hidden", "true");
    siteOverlay.classList.remove("!opacity-100");
    form.reset();
    ctx.hydrate({
      searchDrawer: _objectSpread(_objectSpread({}, ctx.getState().searchDrawer), {}, {
        isActive: false
      })
    });
  };
  var handleSubmit = function handleSubmit(event) {
    var isActive = ctx.getState().searchDrawer.isActive;
    if (isActive) {
      ctx.hydrate({
        searchDrawer: _objectSpread(_objectSpread({}, ctx.getState().searchDrawer), {}, {
          isActive: false
        })
      });
    } else {
      event.preventDefault();
      setActive();
    }
  };
  var handleClickOutside = function handleClickOutside(event) {
    if (event.target.closest("[data-search-drawer-trigger]")) {
      return;
    }
    if (!event.target.closest(".SearchDrawer")) {
      setInactive();
    }
  };
  var handleActiveToggle = function handleActiveToggle() {
    var isActive = ctx.getState().searchDrawer.isActive;
    if (isActive) {
      setInactive();
    } else {
      setActive();
    }
  };
  node.addEventListener("submit", handleSubmit);
  document.addEventListener("click", handleClickOutside);
  searchOpenTriggers.forEach(function (trigger) {
    trigger.addEventListener("click", handleActiveToggle);
  });
  return function () {
    node.removeEventListener("submit", handleSubmit);
    document.removeEventListener("click", handleClickOutside);
    window.removeEventListener("scroll", setInactive);
    searchOpenTriggers.forEach(function (trigger) {
      trigger.removeEventListener("click", handleActiveToggle);
    });
  };
}));

/***/ }),

/***/ "./theme/scripts/lib/currency.js":
/*!***************************************!*\
  !*** ./theme/scripts/lib/currency.js ***!
  \***************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: function() { return /* binding */ formatMoney; }
/* harmony export */ });
/* eslint-disable no-template-curly-in-string */
/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */

// eslint-disable-next-line import/prefer-default-export
function formatMoney(cents) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "${{amount}}";
  var withoutZero = arguments.length > 2 ? arguments[2] : undefined;
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ",";
    decimal = decimal || ".";
    if (Number.isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split(".");
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(thousands));
    var centsAmount = parts[1] ? decimal + parts[1] : "";
    if (withoutZero) {
      // eslint-disable-next-line no-useless-escape
      centsAmount = centsAmount.replace(/[\.,]0{2}/, "");
    }
    return dollarsAmount + centsAmount;
  }
  switch (format.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }
  return format.replace(placeholderRegex, value);
}

/***/ }),

/***/ "./theme/scripts/pages/Product.js":
/*!****************************************!*\
  !*** ./theme/scripts/pages/Product.js ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _lib_currency__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/lib/currency */ "./theme/scripts/lib/currency.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_1__.component)(function (node) {
  var optionsContainer = node.querySelector(".custom-options");
  var priceContainer = node.querySelector(".product-price .current-price");
  var oldPriceContainer = node.querySelector(".product-price .old-price");
  if (!optionsContainer) {
    return;
  }
  var productJson = JSON.parse(node.querySelector("[data-custom-product-json]").innerHTML || {});
  var currentVariantId = productJson.selected_variant_id;
  var currentVariant = productJson.product.variants.find(function (variant) {
    return variant.id === currentVariantId;
  });
  var selects = optionsContainer.querySelectorAll(".custom-options-select");
  var state = {
    items: [],
    getPrice: function getPrice() {
      if (this.items.length === 0) {
        return 0;
      }
      return this.items.map(function (item) {
        return item.price;
      }).reduce(function (acc, curr) {
        return acc + curr;
      });
    }
  };
  var cache = {
    currentProduct: _objectSpread({}, JSON.parse(node.querySelector("[data-custom-product-json]").innerHTML || {})),
    relatedProducts: {}
  };
  selects.forEach(function (select) {
    var relatedProducts = select.nextElementSibling && JSON.parse(select.nextElementSibling.innerHTML || []);
    if (relatedProducts.length) {
      // eslint-disable-next-line camelcase
      relatedProducts.forEach(function (_ref) {
        var product = _ref.product,
          options_with_values = _ref.options_with_values;
        cache.relatedProducts[product.id] = {
          product: product,
          options_with_values: options_with_values
        };
      });
    }
  });
  function hasOption(productObject) {
    var optionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Size";
    return productObject.options_with_values.find(function (option) {
      return option.name === optionName;
    });
  }
  function handleUpdateSelectOptions(options) {
    options.forEach(function (option) {
      var productId = option.dataset.productId;
      if (productId) {
        var relatedProductSizeOption = hasOption(cache.relatedProducts[productId]);
        var productSizeOption = hasOption(cache.currentProduct);
        if (relatedProductSizeOption && productSizeOption) {
          var _cache$relatedProduct = cache.relatedProducts[productId],
            product = _cache$relatedProduct.product,
            variants = _cache$relatedProduct.product.variants;
          variants.forEach(function (relatedProductVariant) {
            if (relatedProductVariant["option".concat(relatedProductSizeOption.position)] === currentVariant["option".concat(productSizeOption.position)]) {
              var optionTitle;
              if (relatedProductVariant.available) {
                optionTitle = "".concat(product.title, " - ").concat((0,_lib_currency__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(relatedProductVariant.price));
              } else {
                optionTitle = "".concat(product.title, " - ").concat(window.languages.productFormSoldOut);
              }
              option.dataset.price = relatedProductVariant.price;
              option.innerText = optionTitle;
            }
          });
        }
      }
    });
  }
  function handleUpdateItems() {
    state.items = [];
    selects.forEach(function (select) {
      handleUpdateSelectOptions(Object.values(select.options));
      var isNotBlankOption = !select.options[select.selectedIndex].dataset.optionBlank;
      var isBlankOption = !isNotBlankOption;
      if (select.value && isNotBlankOption) {
        select.name = select.dataset.optionName;
        var selectedOption = select.options[select.selectedIndex];
        var selectedOptionPrice = selectedOption.dataset.price || 0;
        var productId = selectedOption.dataset.productId;
        var variants = cache.relatedProducts[productId].product.variants;
        var variantId = parseInt(select.value, 10);
        var currentOptionVariant = variants.find(function (v) {
          return v.id === variantId;
        });
        var productSizeOption = hasOption(cache.currentProduct);
        var relatedProductSizeOption = hasOption(cache.relatedProducts[productId]);
        if (relatedProductSizeOption && productSizeOption) {
          variants.forEach(function (relatedProductVariant) {
            if (relatedProductVariant["option".concat(relatedProductSizeOption.position)] === currentVariant["option".concat(productSizeOption.position)]) {
              currentOptionVariant = relatedProductVariant;
            }
          });
        }
        if (currentOptionVariant.available) {
          state.items.push({
            id: currentOptionVariant.id,
            quantity: 1,
            price: parseInt(selectedOptionPrice, 10)
          });
        }
      } else if (isBlankOption) {
        select.name = "properties[".concat(select.dataset.optionName, "]");
      }
    });
  }
  function handleUpdateGlobalPrice() {
    priceContainer = node.querySelector(".product-price .current-price");
    oldPriceContainer = node.querySelector(".product-price .old-price");
    var newPrice = state.getPrice() + currentVariant.price;
    var newOldPrice = state.getPrice() + productJson.product.compare_at_price;
    priceContainer.innerText = (0,_lib_currency__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(newPrice);
    if (productJson.product.compare_at_price && oldPriceContainer) {
      oldPriceContainer.innerText = (0,_lib_currency__WEBPACK_IMPORTED_MODULE_2__.formatMoney)(newOldPrice);
    }
  }
  function handleOptionChange() {
    handleUpdateItems();
    handleUpdateGlobalPrice();
  }
  function handleFormSubmit() {
    if (state.items.length === 0) {
      return;
    }
    fetch("/cart/add.js", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: state.items
      })
    }).then(function () {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true
      }));
    });
  }
  selects.forEach(function (select) {
    select.addEventListener("change", handleOptionChange);
  });
  handleUpdateItems();
  document.addEventListener("product:added", function (event) {
    var variant = event.detail.variant; // Get the variant that was added
    var quantity = event.detail.quantity; // Get the quantity that was added

    handleFormSubmit();
  });
  document.addEventListener("variant:changed", function (event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details

    currentVariantId = variant.id;
    currentVariant = variant;
    handleOptionChange();
  });
}));

/***/ }),

/***/ "./theme/styles/index.css":
/*!********************************!*\
  !*** ./theme/styles/index.css ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js ***!
  \**********************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   component: function() { return /* binding */ u; },
/* harmony export */   picoapp: function() { return /* binding */ c; }
/* harmony export */ });
var n=function(n){if("object"!=typeof(t=n)||Array.isArray(t))throw"state should be an object";var t},t=function(n,t,r,e){return(o=n,o.reduce(function(n,t,r){return n.indexOf(t)>-1?n:n.concat(t)},[])).reduce(function(n,r){return n.concat(t[r]||[])},[]).map(function(n){return n(r,e)});var o};function r(r){void 0===r&&(r={});var e={};return{getState:function(){return Object.assign({},r)},hydrate:function(o){return n(o),Object.assign(r,o),function(){var n=["*"].concat(Object.keys(o));t(n,e,r)}},on:function(n,t){return(n=[].concat(n)).map(function(n){return e[n]=(e[n]||[]).concat(t)}),function(){return n.map(function(n){return e[n].splice(e[n].indexOf(t),1)})}},emit:function(o,u,c){var i=("*"===o?[]:["*"]).concat(o);(u="function"==typeof u?u(r):u)&&(n(u),Object.assign(r,u),i=i.concat(Object.keys(u))),t(i,e,r,c)}}}r();var e=function(n){return"object"==typeof n&&!Array.isArray(n)},o=function(n){return"function"==typeof n};function u(n){return function(t,r){var e=[];return{subs:e,unmount:n(t,Object.assign({},r,{on:function(n,t){var o=r.on(n,t);return e.push(o),o}})),node:t}}}function c(n,t,u){void 0===n&&(n={}),void 0===t&&(t={}),void 0===u&&(u=[]);var c=r(t),i=[];return{on:c.on,emit:c.emit,getState:function(){return c.getState()},add:function(t){if(!e(t))throw"components should be an object";Object.assign(n,t)},use:function(n){if(!o(n))throw"plugins should be a function";u.push(n)},hydrate:function(n){return c.hydrate(n)},mount:function(t){void 0===t&&(t="data-component"),t=[].concat(t);for(var r=0;r<t.length;r++){for(var a=t[r],f=[].slice.call(document.querySelectorAll("["+a+"]")),s=function(){for(var t=f.pop(),r=t.getAttribute(a).split(/\s/),s=0;s<r.length;s++){var v=n[r[s]];if(v){t.removeAttribute(a);try{var d=u.reduce(function(n,r){var o=r(t,c);return e(o)?Object.assign(n,o):n},{}),m=v(t,Object.assign({},d,c));o(m.unmount)&&i.push(m)}catch(n){console.error(n),c.emit("error",{error:n}),c.hydrate({error:void 0})}}}};f.length;)s();c.emit("mount")}},unmount:function(){for(var n=i.length-1;n>-1;n--){var t=i[n],r=t.subs;(0,t.unmount)(t.node),r.map(function(n){return n()}),i.splice(n,1)}c.emit("unmount")}}}
//# sourceMappingURL=picoapp.es.js.map


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/regeneratorRuntime.js":
/*!************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/regeneratorRuntime.js ***!
  \************************************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/typeof.js")["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/typeof.js":
/*!************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/typeof.js ***!
  \************************************************************************************************/
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/regenerator/index.js":
/*!***************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/regenerator/index.js ***!
  \***************************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(/*! ../helpers/regeneratorRuntime */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/regeneratorRuntime.js")();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js ***!
  \**************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js");

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/toPrimitive.js":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/toPrimitive.js ***!
  \*********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ toPrimitive; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/typeof.js");

function toPrimitive(t, r) {
  if ("object" != (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js ***!
  \***********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ toPropertyKey; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _toPrimitive_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/toPrimitive.js");


function toPropertyKey(t) {
  var i = (0,_toPrimitive_js__WEBPACK_IMPORTED_MODULE_1__["default"])(t, "string");
  return "symbol" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(i) ? i : i + "";
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!****************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.24.7/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \****************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!********************************!*\
  !*** ./theme/scripts/index.js ***!
  \********************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _styles_index_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../styles/index.css */ "./theme/styles/index.css");
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/app */ "./theme/scripts/app.js");


if (window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () {
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].unmount();
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
  });
  document.addEventListener("shopify:section:unload", function () {
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].unmount();
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
  });
}
_app__WEBPACK_IMPORTED_MODULE_1__["default"].on("app:update", function () {
  _app__WEBPACK_IMPORTED_MODULE_1__["default"].unmount();
  _app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
});
_app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
}();
/******/ })()
;